import axios from 'axios';
import store from '../store'
import qs from 'qs';
import {formConfig} from "./config";
import {Message, Loading} from 'element-ui';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import Vue from "vue";

//1、创建axios 实例
const service = axios.create(formConfig);

// todo 添加一个请求拦截器，用于设置请求过渡状态
service.interceptors.request.use((config) => {
  // config.headers['Authorization'] = 'Basic YXBwOmFwcA==';
  // 请求开始，蓝色过渡滚动条开始出现
  NProgress.start();
  return config;
}, (error) => {
  return Promise.reject(error);
});

// todo 添加一个返回拦截器
service.interceptors.response.use((response) => {
  // 请求结束，蓝色过渡滚动条消失
  NProgress.done();
  return response;
}, (error) => {
  // 请求结束，蓝色过渡滚动条消失
  // 即使出现异常，也要调用关闭方法，否则一直处于加载状态很奇怪
  NProgress.done();
  return Promise.reject(error);
});

/**
 * 核心函数，可通过它处理一切请求数据，并做横向扩展
 * @param {url} 请求地址
 * @param {params} 请求参数
 * @param {options} 请求配置，针对当前本次请求；
 * @param loading 是否显示loading
 * @param mock 本次是否请求mock而非线上
 * @param error 本次是否显示错误
 */
function request(url, params, options = {loading: true, mock: false, error: true}) {
  let loadingInstance;
  // 请求前loading
  if (params.loading) loadingInstance = Loading.service();
  return new Promise((resolve, reject) => {
    let data = {}
    // get请求使用params字段
    if (params.method == 'get') data = {params: params.data};
    // post请求使用data字段
    if (params.method == 'post') data = {data: params.data};
    let a = qs.stringify(params.data);
    service({url, method: params.method, data: a,}).then((res) => {
      if (res.status === 200) {
        resolve(res.data);
      }
      if (params.promptMessage) {
        Message.success(params.promptMessage);
      }
    }).catch((error) => {
      //todo 处理错误(可以获取到error.response和error.message)
      if (error.response && error.response.status == 426) {
        //用户名密码错误
        store.commit('login/updateState', {state: 'loginTips', update: error.response.data.msg})
        // Message.error(error.response.data.msg);
      }
    }).finally(() => {
      //关闭加载
      loadingInstance.close();
    })
  })
}

export default request;




// WEBPACK FOOTER //
// ./src/utils/formRequest.js